import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWeighingCombinerTickets(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WEIGHING_COMBINER_TICKETS,
		ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKETS,
		options
	)
}
function _getWeighingCombinerTicket(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WEIGHING_COMBINER_TICKETS,
		ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET,
		options
	)
}
function _getWeighingCombinerTicketPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WEIGHING_COMBINER_TICKETS,
		ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET_PREVIEW,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKETS]: _getWeighingCombinerTickets,
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET]: _getWeighingCombinerTicket,
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET_PREVIEW]: _getWeighingCombinerTicketPreview,
}
